import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const QuoteStatusHeaderWrapper = styled.div`
  padding: ${Spacing.S8} ${Spacing.S8} 0;
`
